import { formatPrice } from "@grandvisionhq/utils";
const getDiscount = (prices, locale) => {
  if (!Array.isArray(prices) || !prices[0]) {
    return void 0;
  }
  const { discounted } = prices[0];
  if (!discounted || !discounted.discount?.obj) return void 0;
  const { value, isActive } = discounted.discount?.obj;
  return value.type === "absolute" ? getAbsoluteDiscount(value, isActive, locale) : getRelativeDiscount(value, isActive);
};
const getAbsoluteDiscount = (value, isActive, locale) => {
  if (!value.money[0]) {
    return void 0;
  }
  const { centAmount, currencyCode } = value.money[0];
  if (centAmount === 0 || !isActive) return void 0;
  return `-${formatPrice({
    locale,
    value: centAmount,
    currency: currencyCode,
    isCentAmount: true
  })}`;
};
const getRelativeDiscount = (value, isActive) => value.permyriad !== 0 && isActive ? `-${value.permyriad / 100}%` : void 0;
export {
  getDiscount
};
//# sourceMappingURL=get-discount.js.map
